import antdFA from "antd/lib/locale-provider/fa_IR";
import faMessages from "../locales/fa_IR.json";

const FaLang = {
  messages: {
    ...faMessages,
  },
  antd: antdFA,
  direction: "rtl",
  locale: "fa",
};

export default FaLang;
